<template>
  <div>
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card flat tile>
      <v-toolbar flat color="#ececec" height="60" class="fixed-bar">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-truck</v-icon>
           {{ titulo }}
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text v-if="paso1">
        <v-toolbar class="my-2">
          <v-btn small color="blue" dark @click="nuevaRecepcion()"
            ><v-icon>mdi-plus</v-icon>Nueva recepción</v-btn
          >          
        </v-toolbar>
        <v-form ref="formRecepcion">
        <v-row class="pa-4">
          <v-col cols="12" class="px-4 py-0">                        
            <v-autocomplete
              class="py-0"
              v-model="datosConductor"
              label="Conductor"
              :items="conductores"
              item-text="ENTE_NOMBRE"
              item-value="ENTE_ID"
              return-object
              :rules="requiredRule"              
              @change="cargarDatosConductor()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="px-4 py-0">            
            <br/>
            <v-text-field
              class="py-0"
              label="Fecha"
              :rules="requiredRule"
              v-model="datosRec.RCARGA_FECHA"
            >            
          </v-text-field>
          </v-col>

          <v-col cols="12" class="px-4 py-0">
            <v-text-field
              class="py-0"
              label="Placa"
              :rules="requiredRule"
              v-model="datosRec.RCARGA_PLACA"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="px-4 py-0">
            <v-autocomplete
              :rules="requiredRule"
              class="py-0"
              v-model="datosRec.USUARIO_ID"
              label="Recibido por"
              :items="usuarios"
              item-text="ENTE_NOMBRE"
              item-value="ENTE_ID"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="px-4 pt-0 pb-4">
          <v-col cols="12"
            ><v-btn @click="guardarRcarga()" small color="primary" dark
              ><v-icon>mdi-arrow-right-bold</v-icon>Siguiente</v-btn
            ></v-col
          >
        </v-row>
        </v-form>
      </v-card-text>

      <!-- buscar fincas y guias hijas -->
      <v-card-text v-if="paso2">
        <v-toolbar flat>
           <v-col cols="3">
            {{ fechaCoord }}
              <v-autocomplete
                clearable
                v-model="fechaCoord"
                label="Fecha"
                :items="fechasCoord"
                item-text="HCOORD_FECHA"
                item-value="HCOORD_ID"
                @change="cargarGuiasHijas()"></v-autocomplete>
           </v-col>
          <v-col cols="4">
            <v-autocomplete
              clearable
              v-model="datosCoord"
              label="Finca"
              :items="fincas"
              item-text="ENTE_NOMBRE"
              item-value="ENTE_ID"
              @change="cargarGuiasHijas()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            
            <v-autocomplete
              clearable
              v-model="datosGuiam"
              label="Guias"
              :items="guiasm"
              item-text="AWB"
              item-value="CABECERA_ID"
              @change="cargarGuiasHijas()"
            >
            
            
            <template v-slot:item="data">
              <template>
              <v-list-item-content>
                <v-list-item-title
                  v-html="data.item.AWB"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="data.item.FECHA_COORD"
                ></v-list-item-subtitle>
              </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="datosHawb" label="HAWB"></v-text-field>
          </v-col>
        </v-toolbar>

        <v-row class="px-2">
          <v-col cols="12" class="pa-4">
            <v-data-table
              :item-class="colorFila"
              :items="guiasHijas"
              :headers="headerDetalle"
            >
              <template v-slot:item.opciones="{ item }">
                <v-btn small icon @click="agregarItem(item)"
                  ><v-icon>mdi-plus</v-icon></v-btn
                >
              </template>
              <template v-slot:item.NUM_GUIA_FINCA="{ item }"
                >                
                {{item.NUM_GUIA_FINCA}}<br>
                <span style="font-size:x-small">{{ item.FECHA }} </span>
              </template>
              <template v-slot:item.FINCA="{ item }"
                >{{ item.FINCA.substring(0,32) }} 
                </template>
              <template v-slot:item.SCLIENTE="{ item }"
                >{{ item.SCLIENTE.substring(0,32) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- <v-row class="px-4 mb-2 py-0">
          <v-col cols="12"
            ><v-btn @click="mostrarPaso3()" small color="primary" dark
              ><v-icon>mdi-arrow-right-bold</v-icon>Siguiente</v-btn
            ></v-col
          >
        </v-row> -->
      </v-card-text>

      <!-- ingresar temperaturas -->
      <v-card-text v-if="paso2">
        
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon class="mb-1">mdi-thermometer</v-icon>
            Ingresar temperatura
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>

        <v-data-table :items="itemsRcarga" :headers="headerDetRcarga">
          <template v-slot:item.opciones="{ item }">
            <v-btn small icon @click="borrarItem(item)"
              ><v-icon small>mdi-delete</v-icon></v-btn
            >
            <v-btn small icon @click="editarItem(item)"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
          </template>
        </v-data-table>

        <v-row class="pa-2">
          <!-- <v-col cols="6"
            ><v-btn small color="blue" dark
              ><v-icon>mdi-plus</v-icon>Agregar otro item</v-btn
            ></v-col
          > -->
          <v-col cols="6">
            <v-btn @click="pasoSiguiente(3)" small color="primary" dark
              ><v-icon>mdi-arrow-right-bold</v-icon>Finalizar</v-btn
            >
          </v-col>
          
        </v-row>
      </v-card-text>

      <!-- guardar datos e imprimir -->
      <v-card-text v-if="paso3">
        <v-toolbar>
          <v-toolbar-title>
            <v-icon class="mb-1">mdi-invoice-text-send-outline</v-icon>
            Finalizar
          </v-toolbar-title>
          <v-col>
            RECIBO#: {{ numRecibo }}
          </v-col>
          <v-divider class="mx-4" inset vertical></v-divider>
          
        </v-toolbar>
        <v-row>
          <v-col cols="12">
            <v-alert type="info" dense class="mb-0 py-1">
              <v-icon class="mr-1">mdi-information-outline</v-icon>
              Para enviar el correo de la firma debes ingresar el correo de la
              finca y el correo del conductor
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10">
           
            <v-data-table
              :headers="headersEmailsFincas"
              :items="emailsFincas"
              :items-per-page="10"
              class="elevation-1"
              hide-default-footer
            >
              <template v-slot:item.opciones="{ item }">                
                <v-btn small icon @click="editarCorreoFinca(item)"
                  ><v-icon color="orange">mdi-pencil</v-icon></v-btn
                >
              </template>

              <template v-slot:item.notif="{ item }">
                <v-btn small icon @click="agregarCorreoFinca(item)"
                  ><v-icon color="green">mdi-plus</v-icon></v-btn
                >
                <v-btn small icon @click="eliminarCorreoFinca(item)"
                  ><v-icon color="red">mdi-minus</v-icon></v-btn
                >
              </template>
              <template v-slot:item.CORREO1="{ item }">
                <v-icon v-if="item.TIPO_NOTIF_ID==1" color="blue" small>mdi-bell</v-icon>
                <v-icon v-else="item.TIPO_NOTIF_ID!=1" small>mdi-blank</v-icon>
                {{ item.CORREO1 }}
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="2">                      
            <v-btn class="mb-4" label="recargar lista de contactos" small color="blue" dark @click="cargarEmailsFincas()"><v-icon>mdi-refresh</v-icon></v-btn>
            <br>
            <v-btn small label="agregar contacto finca"  color="primary" dark @click="abrirDialogCorreoFinca()"
              ><v-icon>mdi-plus</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-form ref="formConductor">
        <v-row>
          <v-col cols="5">
            <v-text-field
              label="Nombre del conductor"
              v-model="datosConductor.ENTE_NOMBRE"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-text-field
              label="Correo del conductor"
              v-model="datosConductor.CORREO1"
              :rules="emailRules"
            ></v-text-field>            
          </v-col>
          <v-col cols="1" class="pt-4 mt-4">
              <v-btn
              title="Guardar correo"
              small
              color="primary"
              @click="guardarCorreoConductor()"
              ><v-icon >mdi-content-save</v-icon></v-btn>
          </v-col>          
        </v-row>
        </v-form>
        <v-row>
          <v-col>
            <div >
             <VueSignaturePad width="760px" height="360px" ref="signaturePad" style="border: 1px solid black;"/>
             </div>
            <div>
              <!-- <button @click="save">Save</button> -->
              <v-btn x-small color="blue" dark @click="undo">borrar</v-btn>
            </div> 
          </v-col>
        </v-row>
        <v-row class="pa-6">          
          <!-- <v-col cols="4">
            <v-btn small color="primary" dark @click="imprimirRecepcion()"
              ><v-icon left>mdi-printer</v-icon>Imprimir</v-btn
            >
          </v-col> -->

          <v-col cols="4">
            <v-btn small color="primary" dark @click="guardarRecepcion()"
              ><v-icon>mdi-send</v-icon>Guardar</v-btn
            >
          </v-col>

          <v-col cols="4">
            <v-btn small color="primary" dark @click="imprimirRecepcion()"
              ><v-icon left>mdi-printer</v-icon>Imprimir</v-btn
            >
          </v-col>

          <v-col cols="4">
            <v-btn small color="primary" @click="pasoSiguiente(2)" dark
              ><v-icon>mdi-arrow-left</v-icon>Anterior</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>

      <!-- fin card principal -->
    </v-card>
    <!-- DIALOGO INGRESO DE TEMPERATURA -->
    <v-dialog v-model="dialogIngresarTemp" width="50%">
      <v-card>
        {{ modificarItem }}
        <v-toolbar height="40" flat
          ><v-toolbar-title>Ingresar cajas</v-toolbar-title></v-toolbar
        >
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                label="Cajas"
                v-model="datosItemRcarga.CAJAS_REC"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Temperatura 1"
                v-model="datosItemRcarga.TEMP1"
              ></v-text-field>
            </v-col>
            
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Observaciones"
                v-model="datosItemRcarga.OBSERV"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-toolbar>
          <v-col>
            <v-btn small color="primary" @click="guardarTemp()" dark
              ><v-icon>mdi-content-save</v-icon>Guardar</v-btn
            >
          </v-col>

          <v-col>
            <v-btn small color="primary" @click="modificarTemp()" dark
              ><v-icon>mdi-content-save</v-icon>Modificar </v-btn
            >
          </v-col>
        </v-toolbar>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCorreoFinca" width="50%">
      <v-card>
        <v-toolbar height="40" flat
          ><v-toolbar-title>Correo de finca</v-toolbar-title></v-toolbar
        >
        <v-card-text>
          <v-row >
            <v-col cols="12">
              <v-text-field
                label="Nombre"
                v-model="datosCorreoFinca.NOMBRE"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Correo"
                v-model="datosCorreoFinca.CORREO1"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-toolbar>
          <v-col>
            <v-btn small color="primary" @click="guardarCorreoFinca()" dark
              ><v-icon>mdi-content-save</v-icon>Guardar</v-btn
            >
          </v-col>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 1px;
  z-index: 2;
}
.fila_verde {
  background-color: #b2f78a;
}
.fila_amarilla {
  background-color: #f7eda5;
}
.fila_roja {
  background-color: "red";
}
</style>
<script>



import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";
import Vue from "vue";
import VueSignaturePad from 'vue-signature-pad';

Vue.use(VueSignaturePad);

export default {
  name: "RecibirCajas",
  components: {},
  props: {},
  data: () => ({
    overlay: false,
    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        String(v)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Ingrese un Email válido",
    ],
    titulo: "1. Inicio",
    datosRec: {
      RCARGA_ID: "",
      RCARGA_PLACA: "",      
      USUARIO_ID: "",
      CABECERA_ID: "",
      HCOORD_ID: "",
      COND_ID: "",
      RCARGA_FECHA: "",
      RCARGA_HORA: "",
    },
    correoConductor: "",
    correosFincas:[],
    conductores: [],
    usuarios: [],
    fincas: [],
    guiasm: [],
    datosCoord: [],
    fechasCoord: [],
    fechaCoord : "",
    datosGuiam: "",
    datosHawb: "",
    headerDetalle: [
      { text: "", align: "start", value: "opciones", width: "20" },
      { text: "GUIA", align: "start", value: "NUM_GUIA_FINCA" },
      { text: "Finca", align: "start", value: "FINCA" },
      { text: "Cliente", align: "start", value: "SCLIENTE" },
      { text: "Coordinado", align: "start", value: "BOXES_COORD" },
      { text: "Recibido", align: "start", value: "CAJAS_REC" },
      { text: "Confirmado", align: "start", value: "CAJAS_CONF" },
      { text: "Cliente", align: "start", value: "CAJAS_REC" },
    ],
    guiasHijas: [],
    buscarFinca: "",

    headerDetRcarga: [
      { text: "Opciones", align: "start", value: "opciones" },
      { text: "Finca", align: "start", value: "FINCA_NOMBRE" },
      { text: "Cliente", align: "start", value: "SCLIENTE_NOMBRE" },
      { text: "Cajas rec", align: "start", value: "CAJAS_REC" },
      { text: "Temp", align: "start", value: "TEMP" },
      { text: "Peso", align: "start", value: "PESO" },
      { text: "Estado caja", align: "start", value: "ECAJA_NOMBRE" },
      { text: "Observaciones", align: "start", value: "OBSERV" },
    ],
    headersEmailsFincas: [
      { text: "", value: "opciones" },
      { text: "Enviar Notificacion", value: "notif" },
      { text: "Contacto", value: "NOMBRE" },
      { text: "Email", value: "CORREO1" },
      { text: "Finca", value: "FINCA_NOMBRE" },
      { text: "Codigo", value: "CONTACTO_ID" },
      
    ],
    itemsRcarga: [],
    paso1: true,
    paso2: false,
    paso3: false,
    paso4: false,
    dialogIngresarTemp: false,
    datosItemRcarga: {},
    datosConductor: null,
    emailsFincas:[],
    dialogCorreoFinca: false,
    datosCorreoFinca: {},
    usuario: null,
    numRecibo: "",
    modificarItem: false,
  }),
  computed: {
    ...mapState("master", ["loadingBtn"]),
  },
  methods: {
    ...mapActions("master", ["requestApi", "alertNotification"]),
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setTitleToolbar",
      "setLoadingTable",
      "setDrawer",
    ]),
    ...mapActions("master", ["requestApi", "alertNotification"]),
    
    pasoSiguiente(n) {
      if (n == 1) {
        this.paso1 = this.paso2 = this.paso3 = this.paso4 = false;
        this.paso2 = true;
        this.titulo = "1. Inicio";
      }
      if (n == 2) {
        this.paso1 = this.paso2 = this.paso3 = this.paso4 = false;
        this.paso2 = true;
        this.titulo = "2. Selección de guías";
      }
      if (n == 3) {
        if(this.itemsRcarga.length == 0) {
          this.alertNotification({
            param: {
              title: "Error!",
              icon: "error",
              html: "Debe ingresar al menos una caja",
              confirmButtonColor: "#d60400",
              
            },
          });
          return false;
        }
        this.cargarEmailsFincas();
        this.paso1 = this.paso2 = this.paso3 = this.paso4 = false;
        this.paso3 = true;
        this.titulo = "3. Firmas y envío";
      }
    },
    cargarDatosForm() {
      this.overlay = true;
      this.setLoadingTable(true);
      this.setUrl("api/datos-form-rcarga");
      this.requestApi({
        method: "GET",
        data: {},
      })
        .then((res) => {
          this.fincas = res.data.fincas;
          this.conductores = res.data.conductores;
          this.usuarios = res.data.usuarios;
          this.guiasm = res.data.guias;
          this.usuario = res.data.usuario;
          this.datosRec.USUARIO_ID = this.usuario.ENTE_ID;
          this.fechasCoord = res.data.coord;
          this.setLoadingTable(false);
          this.overlay = false;
        })
        .catch((res) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.setLoadingTable(false);
        });
    },

    cargarGuiasHijas() {
      this.setLoadingTable(true);
      this.setUrl("api/rc-cargar-guiasHijas");
      this.requestApi({
        method: "GET",
        data: {
          num_guia_finca: "",
          awb: this.datosGuiam,
          finca_id: this.datosCoord,
          hcoord_id: this.fechaCoord
        },
      })
        .then((res) => {
          this.guiasHijas = res.data;
          this.setLoadingTable(false);
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    nuevaRecepcion() {
      this.datosRec.RCARGA_FECHA = new Date().toISOString().substring(0, 10);
      this.datosRec.RCARGA_HORA = new Date().toISOString().substring(11, 16);
      this.datosRec.USUARIO_ID = "";
      this.datosRec.COND_ID = "";
      this.datosRec.RCARGA_TIPO=1;
      this.datosRec.RCARGA_PLACA = "";
      this.datosRec.RCARGA_ID = "";
    },

    agregarItem(item) {
      this.modificarItem = false;
      //console.log(item);
      //VERIFICAR SI EL ITEM YA ESTÁN EN LA LISTA
      for (let i = 0; i < this.itemsRcarga.length; i++) {
        if (this.itemsRcarga[i].DETALLE_ID == item.DETALLE_ID) {
          alert("Este item ya se encuentra en la lista");
          return false;
        }
      }
      //console.log(item);
      this.dialogIngresarTemp = true;
      this.datosItemRcarga.BOXES_COORD = parseFloat(
        this.datosItemRcarga.BOXES_COORD
      );
      this.datosItemRcarga.CAJAS_REC = parseFloat(
        this.datosItemRcarga.CAJAS_REC
      );
      Object.assign(this.datosItemRcarga, item);
      this.datosItemRcarga.TEMP1 = 0;
      this.datosItemRcarga.TEMP2 = 0;
      this.datosItemRcarga.TEMP3 = 0;
      this.datosItemRcarga.OBSERV = "";
    },
    borrarItem(item) {
      for (var i = this.itemsRcarga.length - 1; i >= 0; --i) {
        if (this.itemsRcarga[i] == item) {
          this.itemsRcarga.splice(i, 1);
        }
      }
    },
    editarItem(item) {
      this.dialogIngresarTemp = true;
      Object.assign(this.datosItemRcarga, item);
      this.modificarItem = true;
      //abrir dialog ingreso de
      //temperatura
      //cajas recibidas
      //observaciones
      //
    },
    guardarRecepcion() {
      if(!this.$refs.formConductor.validate()) {
        return false;
      }
      //crear recepcion de carga y detalle
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      //console.log(isEmpty);
      //console.log(data);
      if (isEmpty) {
        this.alertNotification({
          param: {
            title: "Error!",
            icon: "error",
            html: "Debe ingresar la firma antes de guardar la recepción",
            confirmButtonColor: "#d60400",
          },
        });
        return false;
      }
      this.setLoadingTable(true);
      this.overlay = true;
      this.setUrl("api/guardar-rcarga");
      this.requestApi({
        method: "POST",
        data: { datosItems: this.itemsRcarga, datosRcarga: this.datosRec, datosFirma: data },

      })
        .then((res) => {          
          this.setLoadingTable(false);
          this.overlay = false;
          this.datosRec.RCARGA_ID = res.data.RCARGA_ID;
          this.numRecibo = res.data.RCARGA_NUM;
          this.alertNotification({ param: { html: res.data.msg } });
          
          //console.log(res);
        })
        .catch((error) => {
          //console.log(error);
          this.overlay = false;
          
          //console.log(error);
          this.alertNotification({ param: { html: res.data.msg } });
          
        })
        .finally(() => {
          this.overlay = false;
          this.setLoadingTable(false);
        });
    },
    imprimirRecepcion() {
      //generar pdf de recepcion
      if(this.datosRec.RCARGA_ID == "") {
        this.alertNotification({
          param: {
            title: "Error!",
            icon: "error",
            html: "Debe guardar la recepción antes de imprimir",
            confirmButtonColor: "#d60400",
          },
        });
        return false;
      }
      this.setLoadingTable(true);
      this.overlay = true;
      this.setUrl("api/imprimir-rcarga");
      this.requestApi({
        method: "POST",
        data: { RCARGA_ID: this.datosRec.RCARGA_ID },
        //data: { RCARGA_ID: "848359" },
        //data: { RCARGA_ID: "848370" },
        
      })
        .then((res) => {          
          this.setLoadingTable(false);
          this.overlay = false;
          let a = document.createElement("a");
          a.href = "data:application/pdf;base64," + res.data.datos;
          a.download = res.data.nombreArchivo;
          a.click();
          //console.log(res);
        })
        .catch((error) => {
          //console.log(error);
          this.overlay = false;
          
          //console.log(error);
          
        })
        .finally(() => {
          this.overlay = false;
          this.setLoadingTable(false);
        });
      
    },
    enviarRecepcion() {
      //mostrar correos a los que se va a enviar el comprobante
      //
    },
    //////
    guardarRcarga() {
      if(!this.$refs.formRecepcion.validate()) {
        return false;
      }
      this.pasoSiguiente(2);
    },
    mostrarPaso3() {      
      this.pasoSiguiente(3);
    },
    modificarTemp() {
        for (let i = 0; i < this.itemsRcarga.length; i++) {
          if (this.itemsRcarga[i].DETALLE_ID == this.datosItemRcarga.DETALLE_ID) {
            this.itemsRcarga[i].CAJAS_REC = this.datosItemRcarga.CAJAS_REC;
            this.itemsRcarga[i].TEMP = this.datosItemRcarga.TEMP1;
            this.itemsRcarga[i].TEMP1 = this.datosItemRcarga.TEMP1;
            this.itemsRcarga[i].OBSERV = this.datosItemRcarga.OBSERV;
          }
        }
      this.dialogIngresarTemp = false;
      
    },
    guardarTemp() {
      //calcular promedio temperatura
      //validar ingreso de cajas
      ///-no ingresar detalle_id duplicado en la misma recepcion
      ///-no sobrepasar el total de cajas coordinadas
      //console.log(this.datosItemRcarga);
      //let TEMP1 =  this.datosItemRcarga.TEMP1,
      //let TEMP2= this.datosItemRcarga.TEMP2;
      //let TEMP3= this.datosItemRcarga.TEMP3;
      /*let temp = (
        (parseInt(this.datosItemRcarga.TEMP1) +
          parseInt(this.datosItemRcarga.TEMP2) +
          parseInt(this.datosItemRcarga.TEMP3)) /
        3
      ).toFixed(2);*/
      const i = {        
        FINCA_NOMBRE: this.datosItemRcarga.FINCA,
        SCLIENTE_ID: "",
        SCLIENTE_NOMBRE: this.datosItemRcarga.SCLIENTE,
        CAJAS_REC: this.datosItemRcarga.CAJAS_REC,
        TEMP: this.datosItemRcarga.TEMP1,
        PESO: 0,
        OBSERV: this.datosItemRcarga.OBSERV,
        DETALLE_ID: this.datosItemRcarga.DETALLE_ID,
        FINCA_ID: this.datosItemRcarga.FINCA_ID,
        CABECERA_ID: this.datosItemRcarga.CABECERA_ID,
        CAJAS_COORD: this.datosItemRcarga.CDSDetalleBOXES_COORD,
        CNEE_ID: this.datosItemRcarga.CNEE_ID,
        SCLIENTE: this.datosItemRcarga.SCLIENTE_ID,
        TIPO_MOV: 1,
        DESC_MOV: "Recepción de carga",
        DETREC_ESTADO: 0,
        CAJAS_DEV: 0,
        TEMP1: this.datosItemRcarga.TEMP1,
        TEMP2: this.datosItemRcarga.TEMP2,
        TEMP3: this.datosItemRcarga.TEMP3,
      };
      

      //self.CDSDetRcargaDETALLE_ID.Value:= self.CDSDetalleDETALLE_ID.Value;
      //self.CDSDetRcargaFINCA_ID.Value:= self.CDSDetalleFINCA_ID.Value;
      //self.CDSDetRcargaCABECERA_ID.Value:= self.CDSDetalleCABECERA_ID.Value;
      //self.CDSDetRcargaCAJAS_COORD.AsFloat:= self.CDSDetalleBOXES_COORD.AsFloat;
      //self.CDSDetRcargaCNEE_ID.Value:= self.CDSDetalleCNEE_ID.Value;
      //self.CDSDetRcargaSCLIENTE_ID.Value:= self.CDSDetalleSCLIENTE_ID.Value;
      //self.CDSDetRcargaRCARGA_ID.Value:= self.CDSRecCargaRCARGA_ID.Value;
      //self.CDSDetRcargaCAJAS_REC.Value:= self.CDSDetalleBOXES_COORD.AsFloat - self.CDSDetalleCAJAS_REC.AsFloat;
      //self.CDSDetRcargaTIPO_MOV.Value:= 1;
      //self.CDSDetRcargaDESC_MOV.Value:='Recepci\F3n de carga';
      //self.CDSDetRcargaDETREC_ESTADO.Value:=0;
      //self.CDSDetRcargaCAJAS_DEV.Value:=0;
      this.itemsRcarga.push(i);
      this.dialogIngresarTemp = false;
    },
    cargarCorreos() {
      //cargar correos de fincas y conductor 
      this.setLoadingTable(true);
      this.setUrl("api/correos-rcarga");
      this.requestApi({
        method: "GET",
        data: {
          finca_id: this.datosCoord,
        },
      })
        .then((res) => {
          this.correos = res.data.correos;
          this.setLoadingTable(false);
        })
        .catch((res) => {
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });
    },
    colorFila(item) {
      if (item.ESTADO_REC == 0) {
        //COLOR_CAJAS_COORD
      }
      if (item.ESTADO_REC == 1) {
        //COLOR_CAJAS_PARCIAL
      }
      if (item.ESTADO_REC == 2) {
        //3 BOXES_COORD
        //4 CAJAS_REC
        //5 CAJAS_CONF
        //6 CAJAS_DEV
        // if self.DBGrid1.Columns[3].Field.AsFloat < self.DBGrid1.Columns[4].Field.AsFloat then
        //                 ColorListo:= ColorCajasMayor;
        //         if self.DBGrid1.Columns[3].Field.AsFloat = self.DBGrid1.Columns[4].Field.AsFloat then
        //                 ColorListo:= ColorCajasRec;
      }
      if (item.ESTADO_REC == 3) {
        // if self.DBGrid1.Columns[4].Field.asFloat > (self.DBGrid1.Columns[5].Field.asFloat + self.DBGrid1.Columns[6].Field.asFloat) then
        //           ColorListo:= ColorCajasEspera;
        //       if self.DBGrid1.Columns[4].Field.asFloat = (self.DBGrid1.Columns[5].Field.asFloat + self.DBGrid1.Columns[6].Field.asFloat) then
        //           ColorListo:= ColorCajasRec;
      }

      return "white";
    },
     undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      //console.log(isEmpty);
      //console.log(data);
    },
    guardarCorreoConductor() {
      this.setUrl("api/guardar-correo-rcarga");
      this.requestApi({
        method: "POST",
        data: {
          conductor_id: this.datosConductor.ENTE_ID,
          correo_conductor: this.datosConductor.CORREO1,
          contacto_id: this.datosConductor.CONTACTO_ID,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarGuiasHijas();
        })
        .catch((error) => {
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });
    },
    cargarDatosConductor(){
      this.datosRec.COND_ID = this.datosConductor.ENTE_ID;
      
    },
    cargarEmailsFincas() {
      let fincasIds = [];
      for(let i=0; i < this.itemsRcarga.length; i++) {
        //recopilar los ids de las fincas sin que se repitan
        if(!fincasIds.includes(this.itemsRcarga[i].FINCA_ID))
          fincasIds.push(this.itemsRcarga[i].FINCA_ID);
      }
      this.setLoadingTable(true);
      this.setUrl("api/correos-fincas-rcarga");
      this.requestApi({
        method: "POST",
        data: {
          fincas: fincasIds,
        },
      })
        .then((res) => {
          this.emailsFincas = res.data.emails;
          this.setLoadingTable(false);
        })
        .catch((error) => {
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });
    },
    
    agregarCorreoFinca(item) {
      //agregar el contacto a la lista de notificaciones
      this.setUrl("api/agregar-contacto-finca-rcarga");
      this.requestApi({
        method: "POST",
        data: {
          contacto_id: item.CONTACTO_ID,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarEmailsFincas();
        })
        .catch((error) => {
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });


      
    },

    editarCorreoFinca(item){
      //editar datos del contacto
      this.dialogCorreoFinca = true;
      this.datosCorreoFinca.FINCA_ID = item.FINCA_ID;
      this.datosCorreoFinca.CONTACTO_ID = item.CONTACTO_ID;
      this.datosCorreoFinca.NOMBRE = item.NOMBRE;
      this.datosCorreoFinca.CORREO1 = item.CORREO1;
    },
    abrirDialogCorreoFinca() {      
      this.dialogCorreoFinca = true;
      this.datosCorreoFinca.CONTACTO_ID = null;
      this.datosCorreoFinca.FINCA_ID = this.datosCoord;
      this.datosCorreoFinca.NOMBRE = "";
      this.datosCorreoFinca.CORREO1 = "";
    },

    
    eliminarCorreoFinca(item){
      //eliminar contacto de la lista de notificaciones
      this.setUrl("api/borrar-contacto-finca-rcarga");
      this.requestApi({
        method: "POST",
        data: {
          contacto_id: item.CONTACTO_ID,          
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarEmailsFincas();
        })
        .catch((error) => {
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });
    },
    guardarCorreoFinca() {
      this.setLoadingTable(true);
      this.setUrl("api/guardar-contacto-finca-rcarga");
      this.requestApi({
        method: "POST",
        data: {
          contacto_id: this.datosCorreoFinca.CONTACTO_ID,
          finca_id: this.datosCorreoFinca.FINCA_ID,
          correo_finca: this.datosCorreoFinca.CORREO1,
          nombre_finca: this.datosCorreoFinca.NOMBRE,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.dialogCorreoFinca = false;
          this.cargarEmailsFincas();
        })
        .catch((error) => {
          this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        }); 
      }
  },

  watch: {
    datosCoord: function (val) {
      if (val == null) {
        this.cargarGuiasHijas();
      }
    },
  },
  beforeMount() {    
    this.setTitleToolbar("Recepción de cajas");
    this.setMenu(true);
    
  },
  beforeUpdate() {       
    this.setDrawer(false)
  },
  mounted() {
    this.cargarDatosForm();
    this.nuevaRecepcion();
  },
};
</script>
